module.exports = __webpack_public_path__ + "static/media/sky-blue-add-vehicle.9c0e0039.svg";